

export class PoiDetailsCompanyOutput implements IPoiDetailsCompanyOutput {
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character */
    company_name!: string;

    constructor(data?: IPoiDetailsCompanyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
        }
    }

    static fromJS(data: any): PoiDetailsCompanyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiDetailsCompanyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        return data; 
    }
}

export interface IPoiDetailsCompanyOutput {
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character */
    company_name: string;
}

